// 次の一戦の絵を、いまの一戦の間に読んでおく (11-01・docs/research/2026-11-01-scene-transition-glitches.md の案1・2)。
//   10-31 作者「場面が切り替わるタイミングで表示されなかったり、過去の軽い絵の残骸が出たりする」。
//   ボスの絵は幕間を読み終えてボスが替わった瞬間に初めて読み始めていた。戦闘前の会話場面を見済みだと
//   そのまま戦いが始まるので、絵が間に合わず「ボスが居ない・前のポーズの絵」が出ていた。
//   いまのボスに替わった時に、次のボスの絵・次の戦闘前の会話場面の絵・いまのボスの幕間の絵を読み始める。
//   開発版の ?prefetchNext=off で入れる前 (替わった瞬間に読むだけ)。
import type { CampaignState } from './types'
import { BOSS_DEFINITIONS } from './bosses'
import { advanceToNextBoss } from './campaign'

export function prefetchNextEnabled(search: string): boolean {
  return new URLSearchParams(search).get('prefetchNext') !== 'off'
}

/** 今のボスを倒した後に戦うボスの id。配布版の区切り・最後のボスなら null。 */
export function nextCampaignBossId(campaign: CampaignState): string | null {
  const next = advanceToNextBoss(campaign)
  if (next.currentBossIndex === campaign.currentBossIndex) return null
  return BOSS_DEFINITIONS[next.currentBossIndex]?.id ?? null
}
